module.exports = __webpack_public_path__ + "static/media/sports_24.c8b4300e.jpg";